import { Injectable } from '@angular/core';
import type { EVendor, TVendor } from '@shared/jp/enums';
import type {
  TBookWrapping,
  TProductAlias,
  TProductOption,
} from '@shared/jp/product';
import type {
  IGiftOrderSpecialCreated,
  IGiftOrderSpecialCreateParams,
  IGiftOrderSpecialGenerated,
  IGiftOrderSpecialPaid,
  IGiftOrderStandartCreated,
  IGiftOrderStandartCreateParams,
  IGiftOrderStandartGenerated,
  IGiftOrderStandartPaid,
  IUserGift,
  IGiftOrderCreateParamsCommon,
  TUserGift,
  TUserGiftError,
  TUserGiftFirestore,
  TGiftOrderCreateParams,
  TGiftOrderCreateParamsError,
  TGiftOrderStandard,
  TGiftOrderSpecial,
  TGiftOrder,
  TGiftOrderError,
  TGiftOrderFirestore,
} from '@shared/jp/gift';
import type {
  IBookSimpleData,
  IOrderData,
  ITaskPrintBookData,
} from '@shared/jp/interfaces';
import type { TBookData } from '@shared/jp/models';
import type {
  IProduction,
  IProductionFB,
} from '@shared/jp/production/interfaces';
import type {
  TRegionNameEnglish,
  TShippingMethod,
} from '@shared/jp/shipping/interfaces';
import { FirebaseService as _FirebaseService } from '@studiobuki/web-core/lib/firebase';
import type { TTicketOrder } from '@shared/jp/ticket';
import type { IDiscountCampaignCommon } from '@shared/common/discount/interfaces';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService extends _FirebaseService<
  TProductAlias,
  TBookWrapping,
  TProductOption,
  TShippingMethod,
  TRegionNameEnglish,
  EVendor,
  TBookData,
  IOrderData,
  IProduction,
  IProductionFB,
  IDiscountCampaignCommon<TVendor>,
  ITaskPrintBookData,
  IBookSimpleData,
  IUserGift,
  TUserGift,
  TUserGiftError,
  TUserGiftFirestore,
  IGiftOrderCreateParamsCommon,
  IGiftOrderStandartCreateParams,
  IGiftOrderStandartCreated,
  IGiftOrderStandartPaid,
  IGiftOrderStandartGenerated,
  IGiftOrderSpecialCreateParams,
  IGiftOrderSpecialCreated,
  IGiftOrderSpecialPaid,
  IGiftOrderSpecialGenerated,
  TGiftOrderCreateParams,
  TGiftOrderCreateParamsError,
  TGiftOrderStandard,
  TGiftOrderSpecial,
  TGiftOrder,
  TGiftOrderError,
  TGiftOrderFirestore,
  TTicketOrder
> {
  // constructor() {}
}
